import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { LogoComponent } from 'app/shared/logo/logo.component';
import { ButtonDirective } from 'app/shared/ui/buttons/button.component';
import { FaIconDirective } from 'app/shared/ui/icon/fa-icon.directive';

@Component({
    selector: 'welcome-layout',
    imports: [
        LogoComponent,
        ButtonDirective,
        FaIconDirective,
        AsyncPipe,
    ],
    styles: [
        `
            ap-logo {
                color: var(--brand-dark);
                padding: 30px 0;
                max-width: 300px;
                margin: 0 auto;
            }
            .about-us {
                display: none;
            }
            .about-us p {
                margin-bottom: 2rem;
            }
            .ap-showcase {
                display: none;
                max-width: 300px;
                margin: 3em auto 0 auto;
            }
            .ap-showcase img {
                max-width: 100%;
                height: auto;
            }
            .side-panel {
                color: black;
                max-width: 400px;
            }
            .login-footer {
                display: none;
                font-size: smaller;
                margin: 15px;
                margin-bottom: 35px;
                padding-right: 15px;
            }
            .login-footer ul {
                position: absolute;
                bottom: 0;
                list-style: none;
                padding: 0;
                margin: 35px 0;
            }
            .login-footer li {
                float: left;
                margin: 0 3px;
            }
            .footer-left a {
                color: white;
            }

            @media (min-width: 576px) {
                .login-footer {
                    display: block;
                }
                .about-us {
                    display: block;
                }
                .ap-showcase {
                    display: block;
                }
                .side-panel {
                    background: #152935;
                    background-image: url(/assets/images/login.png);
                    background-position: bottom;
                    background-repeat: no-repeat;
                    color: #FFF;
                    display: block;
                    height: 100vh;
                    padding: 30px;
                }
                ap-logo {
                    color: white;
                    padding-top: 40px;
                    padding-bottom: 70px;
                }
            }

            @media (min-width: 992px) {
                .about-us, ap-logo {
                    max-width: 300px;
                    margin: 0 auto;
                }
                .login-footer {
                    margin: 35px;
                }
            }
            @media (max-height: 600px) {
                ap-logo {
                    padding-top: 10px;
                    padding-bottom: 20px;
                }
                .login-footer {
                    display: none;
                }
            }

            .content {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
            .links {
                display: none;
                position: absolute;
                bottom: 0;
                right: 0;
                margin: 35px;
                padding-right: 6rem;
                font-size: smaller;
            }

            @media (min-width: 576px) {
                .col-sm-4 {
                    padding-left: 0;
                }
                .container-fluid {
                    max-width: inherit;
                }
                .links {
                    display: block;
                }
            }

            @media (max-height: 600px) {
                .links {
                    display: none;
                }
            }
        `,
    ],
    template: `
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-4 col-lg-3 side-panel-wrapper">
                    <div class="side-panel">
                        <a href="https://autoprop.ca" target="_blank" class="logo-link">
                            <ap-logo></ap-logo>
                        </a>
                        <div class="about-us">
                            <p>
                                "{{ story.text }}"
                            </p>
                            <em>- {{ story.name }}, <strong>{{ story.company }}</strong></em>
                        </div>
                        <div class="ap-showcase">
                            <img src="/assets/images/ap_showcase.png">
                        </div>
                        <div class="login-footer footer-left">
                            <ul>
                                <li><a target="_blank" href="https://autoprop.ca">Autoprop.ca</a></li>
                                <li>|</li>
                                <li><a target="_blank" href="https://autoprop.ca/solutions">Solutions</a></li>
                                <li>|</li>
                                <li><a target="_blank" href="https://autoprop.ca/our-story">Our story</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-8 col-lg-9">
                    @if (isAuthenticated | async) {
                        <div class="btn-toolbar m-3">
                            <button type="button" class="btn btn-secondary ml-auto" title="Logout" (click)="logout()">
                                <i class="fa fa-fw fa-sign-out"></i> Log Out
                            </button>
                        </div>
                    }
                    <div class="content mt-4">
                        <ng-content></ng-content>
                    </div>
                    <div class="links pull-right">
                        Made with <i class="fa fa-heart"></i> in Vancouver and Budweis |
                        AUTOPROP SOFTWARE LTD. All rights reserved. &copy; 2017-{{ currentYear }} |
                        <a href="https://autoprop.ca/privacy-policy-and-terms-of-use" target="_blank">
                            Terms of Service and Privacy Policy
                        </a>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class WelcomeLayoutComponent {

    story = {
        text: `AUTOPROP is the long-awaited ‘Google’ of Vancouver real estate. I’m no longer fishing or hunting for data.
         AUTOPROP links me to all the information I need at speeds I never thought possible.`,
        name: 'Sonny Klair',
        company: 'Sutton Group Mattu Realty',
    };

    currentYear = new Date().getFullYear();

    get isAuthenticated() {
        return this.authService.isAuthenticated();
    }

    constructor(private authService: AuthService) {}

    logout() {
        this.authService.logout().subscribe();
    }
}
